import React from 'react';
import {IconProps} from "../services/IconConstants";

const PencilIcon = ({size, colour, style, className}: IconProps) => {

    return (
        <svg viewBox="0 0 24 24"
             width={size}
             height={size}
             color={colour ? colour : 'var(--text)'}
             style={style}
             className={className}
             fill={"none"}>
                <path d="M21 8L16 3L4 15L3 21L9 20L21 8Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" />
                <path d="M13.5 6.5L17.5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" />
        </svg>
    )
}

export default PencilIcon;